import {Component, EventEmitter, OnDestroy, OnInit, Output} from "@angular/core";
import {Subscription} from "rxjs";
import {SiteDTO} from "../../../core/dtos/site-dto";
import {Auth2Service} from "../../../core/services/security/auth2.service";
import {UtilsService} from "../../../core/utils/utils.service";
import {WizardConditionnementService} from "../../../core/services/conditionnements/conditionnement-wizard.service";
import {InternationalizationService} from "../../../core/services/i8n/i8n.service";
import {ToastService} from "../../../core/services/technique/toast.service";
import {ConditionnementsVarianteService} from "../../../core/services/conditionnements/conditionnement-variante.service";
import ConditionnementVarianteDTO from "../../../core/dtos/conditionnement/conditionnement-variante-dto";
import ConditionnementDTO from "../../../core/dtos/conditionnement/conditionnement-dto";
import {VariantesService} from "../../../core/services/conditionnements/variantes.service";
import {ConditionnementsService} from "../../../core/services/conditionnements/conditionnements.service";
import VarianteDTO from "../../../core/dtos/conditionnement/variante-dto";
import {MSG_KEY, MSG_SEVERITY} from "../../../core/constants";
import {WizardService} from "../../../core/services/wizard-service";

@Component({
  selector: 'yo-wizard-configuration-step-4',
  templateUrl: './wizard-configuration-step-4.component.html',
  styleUrls: ['./wizard-configuration-step-4.component.scss']
})
export class WizardConfigurationStepFourComponent implements OnInit, OnDestroy {

  @Output() onEmitPreviousStep = new EventEmitter<any>();

  @Output() onEmitNextStep = new EventEmitter<any>();

  private currentStep: number;

  conditionnementsVariantes: any[] = [];

  variantes: VarianteDTO[] = [];

  workingVariantes: VarianteDTO[] = [];

  conditionnements: ConditionnementDTO[] = [];

  workingConditionnements: ConditionnementDTO[] = [];

  subConditionnementsVariantes: Subscription;

  currentSite: SiteDTO;

  subVariantes: Subscription;

  subConditionnements: Subscription;

  conditionnementSelected: ConditionnementDTO;

  variantesSelected: VarianteDTO[] = [];

  displayForm: boolean = false;

  enableVariantes: boolean = false;

  constructor(private readonly auth2Svc: Auth2Service,
              private readonly cvSvc: ConditionnementsVarianteService,
              private readonly utilsSvc: UtilsService,
              private readonly wizardSvc: WizardConditionnementService,
              private readonly variantesSvc: VariantesService,
              private readonly conditionnementSvc: ConditionnementsService,
              private readonly i8nSvc: InternationalizationService,
              private readonly toastSvc: ToastService,
              private readonly wizardGlobalSvc: WizardService) {
    this.currentStep = this.wizardSvc.STEP_CONFIG_REFERENTIEL_COMBINAISONS;
  }

  ngOnInit() {
    this.initCurrentSite();
  }

  ngOnDestroy() {
    this.utilsSvc.unsubscribe(this.subConditionnementsVariantes);
    this.utilsSvc.unsubscribe(this.subVariantes);
    this.utilsSvc.unsubscribe(this.subConditionnements);
  }

  toogleDisplayForm = (): void => {
    this.displayForm = true;
  }

  initCurrentSite = (): void => {
    const dataStepOne: any = this.wizardSvc.getDataStepOne();
    const idSelectedSite = dataStepOne.idSelectedSite;
    this.currentSite = this.auth2Svc.utilisateur.siteListLocaux.find(site => site.id === idSelectedSite);
    this.findAllVariantes();
    this.findAllConditionnements();
    this.findAllCombinaisons();
  }

  findAllCombinaisons = (): void => {
    this.subConditionnementsVariantes = this.cvSvc.getAll()
      .subscribe((response) => {
        const results: ConditionnementVarianteDTO[] = response.resultList;
        this.conditionnementsVariantes = results.reduce((result, o) => {
          let idx = result.findIndex(r => r.conditionnement.id === o.conditionnement.id);
          let variante = {id: o.variante.id, libelle: o.variante.libelle};

          if (idx === -1)
            result.push({id: o.conditionnement.id, conditionnement: {id: o.conditionnement.id, libelle: o.conditionnement.libelle}, variantes: [variante]});
          else
            result[idx].variantes.push(variante);
          return result;
        }, []);

        this.updateConditionnements()
      });
  }

  findAllVariantes = (): void => {
    this.subVariantes = this.variantesSvc.getAll()
      .subscribe(response => {
        this.variantes = response.resultList;
        this.updateConditionnements();
      });
  }

  findAllConditionnements = (): void => {
    this.subConditionnements = this.conditionnementSvc.getAll()
      .subscribe(response => {
        this.conditionnements = response.resultList;
        this.updateConditionnements();
      });
  };

  private updateConditionnements = () => {
    if (this.conditionnements && this.conditionnements.length > 0)
      this.workingConditionnements = this.conditionnements.filter(c => {
        if (!this.conditionnementsVariantes || !this.variantes || this.variantes.length == 0)
          return true;
        let cv = this.conditionnementsVariantes.find(cv => c.id === cv.conditionnement.id)
        return cv == undefined || cv.variantes.length < this.variantes.length;
      });
  }

  updateVariantes = (conditionnement) => {
    if (!conditionnement) {
      this.workingVariantes = [];
      this.enableVariantes = false;
    } else {
      const condiVariantes = this.conditionnementsVariantes.find(cv => cv.conditionnement.id === conditionnement.value.id);
      let actualVariantes = condiVariantes ? condiVariantes.variantes.map(v => v.id) : [];
      this.workingVariantes = this.variantes.filter(v => !actualVariantes.includes(v.id));
      this.enableVariantes = true;
    }
  }

  addConditionnementVariante = (): void => {
    if (!this.conditionnementSelected || !this.variantesSelected.length) {
      this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.WARNING, this.i8nSvc.getLabelFromCode('EMPTY_LINE_TABLE', null));
      return;
    }
    const conditionnementToSave: ConditionnementDTO = Object.assign({}, this.conditionnementSelected);
    const variantesToSave: VarianteDTO[] = Object.assign([], this.variantesSelected);

    const dataFromStepOne = this.wizardSvc.getDataStepOne(); // On utilise le site de l'étape 1 pour les référentiels
    const site = {id: dataFromStepOne.idSelectedSite} as SiteDTO;
    const conditionnementsVariantesToSave: ConditionnementVarianteDTO[] = [];
    variantesToSave.forEach((variante) => {
      const conditionnementVariante: ConditionnementVarianteDTO = new ConditionnementVarianteDTO();
      conditionnementVariante.id = undefined;
      conditionnementVariante.site = site;
      conditionnementVariante.conditionnement = Object.assign({}, conditionnementToSave);
      conditionnementVariante.variante = Object.assign({}, variante);
      conditionnementsVariantesToSave.push(conditionnementVariante);
    });

    this.cvSvc.save(conditionnementsVariantesToSave)
      .subscribe(response => {
        this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Le(s) association(s) ont été ajouté(s) avec succès`);
        this.updateOrAddConditionnementVariante(conditionnementToSave, variantesToSave);
        this.updateConditionnements();
        this.updateVariantes(null);
        this.conditionnementSelected = undefined;
        this.variantesSelected = [];
        this.displayForm = false;
      });
  }

  updateOrAddConditionnementVariante = (conditionnement: ConditionnementDTO, variantes: VarianteDTO[]): void => {
    let index = this.conditionnementsVariantes.findIndex(ca => ca.conditionnement.id == conditionnement.id);
    if (index >= 0)
      this.conditionnementsVariantes[index].variantes = this.conditionnementsVariantes[index].variantes.concat(variantes);
    else
      this.conditionnementsVariantes.push({
        id: conditionnement.id,
        conditionnement: Object.assign({}, conditionnement),
        variantes: [...variantes]
      });
  }

  getVariantesForConditionnement = (row: any): string => {
    return (row && row.variantes) ? row.variantes
      .map(v => v.libelle)
      .join(',') : '';
  }

  previous = (): void => {
    this.onEmitPreviousStep.emit({currentStep: this.currentStep});
  }

  next = (): void => {
    this.onEmitNextStep.emit({
      currentStep: this.currentStep,
      conditionnementsVariantes: this.conditionnementsVariantes
    });
  }

  currentStepPourcentage = (): number => this.wizardGlobalSvc.calculateCurrentStepPourcentage(this.wizardSvc.totalSteps, this.currentStep);
}
